const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRankIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92.48 83.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63.58,28.3v52H90.32V53.58H70.81V52.14h21V81.76H2.17V45.64h21v1.44H3.61V80.32H30.35v-52H63.58m-31.79,52H62.14V29.74H31.79V80.32M65,26.85H28.9v52H5.06V48.53H24.57V44.19H.72v39H93.21V50.69H69.36V55H88.87V78.87H65v-52Zm-31.79,52V31.19H60.69V78.87Z",
    transform: "translate(-0.72)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.51,
    y: 31.19,
    width: 27.46,
    height: 47.69,
    style: {
      fill: "#ccebf8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.79,53.11h4.1V43.48H42.61V41.79a10.3,10.3,0,0,0,4-1.21h2V53.11h3.58v2.18H41.79Z",
    transform: "translate(-0.72)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.09,72.28l1.28-1.7a5.74,5.74,0,0,0,3.9,1.6c1.8,0,3.12-.82,3.12-2.2s-1.23-2.51-4.87-2.51V65.53c3.17,0,4.38-1,4.38-2.35s-1-2-2.58-2A5.21,5.21,0,0,0,74,62.6L72.58,61a7.42,7.42,0,0,1,4.85-1.87c3,0,5.16,1.41,5.16,3.89,0,1.65-1.18,2.75-3,3.39v.09c1.91.45,3.47,1.7,3.47,3.66,0,2.67-2.57,4.24-5.59,4.24A7.2,7.2,0,0,1,72.09,72.28Z",
    transform: "translate(-0.72)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.06,72.54c4.59-4,7.37-6.51,7.37-8.79,0-1.55-.95-2.52-2.8-2.52a4.79,4.79,0,0,0-3.24,1.62l-1.47-1.47A6.68,6.68,0,0,1,16,59.09c3,0,5,1.8,5,4.52S18.33,68.92,14.92,72c.88-.08,1.89-.14,2.71-.14h4.14v2.26H11.06Z",
    transform: "translate(-0.72)",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.24.2l1.18,3.63a1,1,0,0,0,.94.68h3.82a.29.29,0,0,1,.17.53L50.26,7.28a1,1,0,0,0-.36,1.11L51.08,12a.29.29,0,0,1-.45.32L47.55,10.1a1,1,0,0,0-1.17,0l-3.09,2.24a.28.28,0,0,1-.44-.32L44,8.39a1,1,0,0,0-.36-1.11L40.58,5a.29.29,0,0,1,.17-.53h3.82a1,1,0,0,0,.94-.68L46.69.2A.29.29,0,0,1,47.24.2Z",
    transform: "translate(-0.72)",
    style: {
      fill: "#66c4eb"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankIcon);
export default __webpack_public_path__ + "static/media/rank-icon.aab0b6359fb1f84f65e2d29c1fad1540.svg";
export { ForwardRef as ReactComponent };